<template>
  <div class="index A03_gszz" id="A03_gszz">
    <div class="title" id="lc" style="margin-top: 0;">
      <div class="txtStyle">公司资质</div>
      <div class="bj"></div>
    </div>
    <div class="showImg">
      <div
        class="card"
        v-for="item in companyQualification"
        :key="item.index"
        @click="clickShowLB(item.index)"
      >
        <!-- <div
          class="picture"
          :style="{ backgroundImage: 'url(' + item.url + ')', ...(item.style || {}) }"
        ></div> -->
        <el-image class="picture" :src="item.url" fit="fill"></el-image>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>

    <div class="title" id="lc">
      <div class="txtStyle">授权证书</div>
      <div class="bj"></div>
    </div>

    <div class="showImg">
      <div
        class="card"
        v-for="item in authorizationCertificate"
        :key="item.index"
        @click="clickShowLB(item.index)"
      >
        <el-image class="picture" :src="item.url" fit="fill"></el-image>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>

    <div class="title" id="lc">
      <div class="txtStyle">荣誉证书</div>
      <div class="bj"></div>
    </div>

    <div class="showImg">
      <div
        class="card"
        v-for="item in honorCertificate"
        :key="item.index"
        @click="clickShowLB(item.index)"
      >
        <el-image class="picture" :src="item.url" fit="cover"></el-image>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>

    <div class="title" id="lc">
      <div class="txtStyle">校企合作</div>
      <div class="bj"></div>
    </div>

    <div class="showImg">
      <div
        class="card"
        v-for="item in schoolEnterpriseCooperation"
        :key="item.index"
        @click="clickShowLB(item.index)"
      >
        <el-image class="picture" :src="item.url" fit="fill"></el-image>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="aaa" v-if="showLB" id="out" @click="hiddenImgs">
      <div class="lunBo">
        <el-carousel
          indicator-position="outside"
          height="1250px"
          :autoplay="false"
          :initial-index="thisItem"
          id="LB"
        >
          <el-carousel-item v-for="item in showData" :key="item.index">
            <div class="pictureLB" id="in" @click="hiddenImgs">
              <img :src="item.url" :alt="item.name" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "A03_gszz",
  data() {
    return {
      showLB: false,
      thisItem: 2,
      showData: [
        {
          index: 0,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic0.png",
          name: "经营证券期货业务许可证",
        },
        {
          index: 1,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic1.png",
          name: "营业执照",
        },
        {
          index: 2,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic2.png",
          name: "深圳市证券业协会会员单位",
        },
        {
          index: 3,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic3.png",
          name: "出版物经营许可证",
        },
        {
          index: 4,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic4.png",
          name: "上证所Level-1行情经营许可证",
        },
        {
          index: 5,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic5.png",
          name: "深交所专有信息经营许可证",
        },
        {
          index: 6,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic6.png",
          name: "企业竞争力行业等级证书",
          // style: { backgroundSize: "100% auto", backgroundPosition: "center" },
        },
        {
          index: 7,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic7.png",
          name: "人工智能数字产业联盟链接者",
        },
        {
          index: 8,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic8.png",
          name: "先进集体",
        },
        {
          index: 9,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic9.png",
          name: "广西英华国际职业学院",
        },
        {
          index: 10,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic10.png",
          name: "深圳信息职业技术学院",
        },
        {
          index: 11,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic11.png",
          name: "广州应用技术学院",
        },
        {
          index: 12,
          url: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/pc-homepage-certificate/pic12.png",
          name: "德讯金服商学院",
        },
      ],
      needData: [],
      currentPage: 1, //初始页
      courseId: "", //后端需要的参数，看个人是否需要
      pageSize: 10, //每页的数据
      pageNum: 1, //后端需要的参数，看个人是否需要
      tableData: [], //定义一个数组，用来接收后端返回的内容
    };
  },
  computed: {
    // 公司资质
    companyQualification() {
      return this.showData.slice(0, 4);
    },
    // 授权证书
    authorizationCertificate() {
      return this.showData.slice(4, 6);
    },
    // 荣誉证书
    honorCertificate() {
      return this.showData.slice(6, 9);
    },
    // 校企合作
    schoolEnterpriseCooperation() {
      return this.showData.slice(9, 13);
    },
  },
  mounted() {
    // this.getdata();
  },
  methods: {
    // 分頁
    getdata() {
      var data = this.showData;
      var currentPage = this.currentPage;
      var result = [];
      for (var i = 0, len = data.length; i < len; i += 9) {
        result.push(data.slice(i, i + 9));
      }
      //console.log("分割后的数据", result);
      this.needData = result[currentPage - 1];
    },
    currentChangeHandle(val) {
      this.currentPage = val;
      this.getdata();
      console.log(val);
    },
    clickShowLB(item) {
      console.log(item);
      this.thisItem = item;
      this.showLB = true;
    },
    hiddenImgs: function (event) {
      event.stopPropagation();
      var target = event.currentTarget;
      if (target.id == "out") {
        this.showLB = false;
      } else {
        this.showLB = true;
      }
    },
  },
};
</script>

<style scoped>
.index {
  /* position: relative; */
  width: 1189px;
  margin-left: 234px;
  overflow: hidden;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: 700;
  line-height: 56px;
  color: rgba(29, 29, 29, 1);
  font-size: 40px;
  text-align: center;
  line-height: 52px;
  margin: 60px auto 20px;
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 710px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
.showImg {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  width: 1176px;
  margin-left: -7px;
  margin-right: -7px;
  padding: 0 2px;
  /* height: 1026px; */
}
.card {
  width: 280px;
  height: 222px;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 8px;
  margin: 0px 7px 14px 7px;
  cursor: pointer;
}
.card:hover .name {
  color: #e7413b;
}
.picture {
  width: 260px;
  height: 162px;
  opacity: 1;
  border-radius: 6px;
  margin: 10px 10px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.name {
  width: 100%;
  height: 33px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25.2px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  margin-top: 14px;
}
/* 分页 */
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}

/* 轮播图 */
#LB /deep/ .el-carousel__container .el-carousel__arrow {
  top: 40%;
  width: 60px;
  height: 60px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow i {
  font-size: 32px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow--right {
  top: 40%;
  right: 350px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow--left {
  top: 40%;
  left: 350px;
}
.aaa {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.lunBo {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.39);
  opacity: 1;
}
.pictureLB {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 762px;
  height: 572px;
  opacity: 1;
  border-radius: 6px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: -400px 0 0 -381px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pictureLB img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutS/A03_gszz.vue